export default {
  title: {
    id: 'product_page_seller_block_title',
    defaultMessage: 'Refurbished by',
  },
  subtitle: {
    id: 'product_page_seller_block_subtitle',
    defaultMessage: 'Reseller since {since}, location: {location}',
  },
  shippedFrom: {
    id: 'product_page_seller_ships_from',
    defaultMessage: 'Ships from',
  },
  paymentMethodAccepted: {
    id: 'product_page_seller_ships_accepted_payment',
    defaultMessage: 'Accepts',
  },
  impactChampion: {
    id: 'product_page_seller_impact_champion',
    defaultMessage: 'Impact champion',
  },
}
